import { createApp } from "@digitalbranch/app";
import { uiIcon, uiIconButton } from "@digitalbranch/scaffold-ui"

import { appMain } from "./components/main/main";

import '@digitalbranch/scaffold-ui/dist/theme/theme.css'
import '@digitalbranch/scaffold-ui/dist/theme/main.css'

const icons = [
 'build_circle',
 'code',
 'step',
 'play_circle',
 'cancel',
 'memory',
 'terminal',
 'hard_drive_2',
 'dark_mode',
 'light_mode',
 'folder',
 'folder_open'
]

createApp({
  el: '#app',
  provide: {
    icons
  },
  components: {
    appMain,
    uiIconButton,
    uiIcon
  }
})